import React, { useState } from 'react';
import deliver1 from './Assets/Jewelry/Double Turtle Charm 1.png';
import deliver2 from './Assets/Jewelry/Trinity Eye Charm 1.png';

// Sample delivery statuses with images
const sampleDeliveries = [
  { id: 1, date: '2024-08-29', description: 'Pending Item 2', status: 'Shipped', image: deliver1 },
  { id: 2, date: '2024-07-20', description: 'Pending Item 4', status: 'Courier', image: deliver2 },
];

const DeliveryStatus = () => {
  const [deliveries, setDeliveries] = useState(sampleDeliveries);

  const handleClearDeliveries = () => {
    setDeliveries([]);
  };

  const containerStyle = {
    width: '90%',
    maxWidth: '600px',
    margin: '0 auto',
    padding: '20px',
    backgroundColor: '#f9f9f9',
    borderRadius: '8px',
    boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
  };

  const headerStyle = {
    fontSize: '24px',
    marginBottom: '20px',
  };

  const buttonStyle = {
    backgroundColor: '#ff4d4d',
    color: 'white',
    border: 'none',
    padding: '10px 20px',
    borderRadius: '5px',
    cursor: 'pointer',
    marginTop: '20px',
    fontSize: '16px',
    width: '100%',
  };

  const buttonHoverStyle = {
    backgroundColor: '#ff1a1a',
  };

  const listStyle = {
    listStyleType: 'none',
    padding: '0',
  };

  const listItemStyle = {
    display: 'flex',
    alignItems: 'center',
    padding: '10px',
    borderBottom: '1px solid #ddd',
  };

  const lastItemStyle = {
    borderBottom: 'none',
  };

  const imageStyle = {
    width: '100px',
    height: '100px',
    marginRight: '20px',
    borderRadius: '5px',
  };

  const contentStyle = {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  };

  const dateStyle = {
    fontWeight: 'bold',
    marginBottom: '5px',
  };

  const descriptionStyle = {
    color: '#555',
    marginBottom: '5px',
  };

  const statusStyle = {
    color: 'green',
    fontWeight: 'bold',
  };

  return (
    <div style={containerStyle}>
      <h1 style={headerStyle}>Delivery Status</h1>
      <ul style={listStyle}>
        {deliveries.length === 0 ? (
          <li style={listItemStyle}>No deliveries available</li>
        ) : (
          deliveries.map((item, index) => (
            <li
              key={item.id}
              style={{ ...listItemStyle, ...(index === deliveries.length - 1 ? lastItemStyle : {}) }}
            >
              <img src={item.image} alt={item.description} style={imageStyle} />
              <div style={contentStyle}>
                <span style={descriptionStyle}>{item.description}</span>
                <span style={dateStyle}>{item.date}</span>
                <span style={statusStyle}>{item.status}</span>
              </div>
            </li>
          ))
        )}
      </ul>
      {/* <button
        onClick={handleClearDeliveries}
        style={buttonStyle}
        onMouseOver={(e) => e.currentTarget.style.backgroundColor = buttonHoverStyle.backgroundColor}
        onMouseOut={(e) => e.currentTarget.style.backgroundColor = buttonStyle.backgroundColor}
      >
        Clear Deliveries
      </button> */}
    </div>
  );
};

export default DeliveryStatus;
